import React, { useState } from 'react';
import './CommonToggleButton.css'
import classnames from 'classnames';


function CommonToggleButton ({
name,
labelName,
Id,
labelFor,
checked ,
onChange,
stylesContainer = {},

}){
return(
<>
<div className="flex w-full mb-6" style ={stylesContainer}>
  

  <label 
    htmlFor={labelFor}
    className="flex items-center cursor-pointer"
  >
  
  <div
      className ="mr-3 text-gray-700 font-medium font-roboto"
    >
    {labelName}
    </div>
    <div className="relative">
 
      <input 
      name ={name}
      id={Id} 
      type="checkbox" 
      className="hidden" 
      checked = {checked}
      onChange={onChange} />
   
      <div
        className ="toggle__line h-5 rounded-full shadow-inner"
      ></div>

      <div
        className="toggle__dot absolute w-4 h-4 bg-white rounded-full shadow inset-y-0 left-0"
      ></div>
    </div>

  </label>
  
</div>
</>
);
}
export default CommonToggleButton;